import React from 'react';
import { FacilityInventoryCountEditTemplate } from 'themes/application/facility-inventory/components';
import { observer } from 'mobx-react';
import { FacilityInventoryCountModalEditViewStore } from 'application/facility-inventory/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityInventoryCountModalEditViewStore(rootStore, componentProps), 'editView')
@observer
class FacilityInventoryCountEdit extends React.Component {
    render() {
        return <FacilityInventoryCountEditTemplate {...this.props} />
    }
}

export default FacilityInventoryCountEdit;